import { render, staticRenderFns } from "./ProdutosOpcionais.vue?vue&type=template&id=03b72bcf&scoped=true"
import script from "./ProdutosOpcionais.vue?vue&type=script&lang=js"
export * from "./ProdutosOpcionais.vue?vue&type=script&lang=js"
import style0 from "./ProdutosOpcionais.vue?vue&type=style&index=0&id=03b72bcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b72bcf",
  null
  
)

export default component.exports